<template>
<div class="newSaleModal">
    <div class="modal is-active ">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{sale.title}}</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <slideshow :items="saleItems"></slideshow>
                <div class="columns is-mobile is-multiline">

                    <div class="column is-3">Art</div>
                    <div class="column is-9">{{getSaleType(sale)}}</div>

                    <div class="column is-3">Preis</div>
                    <div class="column is-9">{{getSalePrice(sale)}}</div>

                    <div class="column is-3">Von</div>
                    <div class="column is-9">{{sale.author.firstname}} {{sale.author.name}}</div>

                    <div class="column is-3">Beschreibung</div>
                    <div class="column is-9">{{sale.description}}</div>
                    
                </div>
            </section>
            <footer class="modal-card-foot">
                <router-link class="button is-success" :to="'/message/create/'+sale.author.id">
                    <button class="button is-success" @click="">Nachricht schreiben</button>
                </router-link>

                <button class="button" @click="closeModal">Abbrechen</button>
            </footer>
        </div>
    </div>
</div>
</template>

<script>
import slideshow from '@/components/Slideshow/slideshow.vue'

export default {
    name: 'showSale',
    props: ["sale"],
    components: {
        slideshow
    },
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],

        }
    },
    methods: {

        closeModal() {
            this.$emit("close")
        },
           getSaleType(sale) {
            switch (sale.type) {
                case 0:
                    return this.$t("enaq_translation_market_new_offer_type_sell");
                    break;
                case 1:
                    return this.$t("enaq_translation_market_new_offer_type_buy");
                    break;
                case 2:
                    return this.$t("enaq_translation_market_new_offer_type_trade");
                    break;
                case 3:
                    return this.$t("enaq_translation_market_new_offer_type_gift");
                    break;
                case 4:
                default:
                    return this.$t("enaq_translation_market_new_offer_type_other");
                    break;
            }
        },
        getSalePrice(sale) {
            if (sale.price != 0 && sale.price != undefined && sale.price != null) {
                return sale.price + "€"
            } else if (sale.individual_reward != '' && sale.individual_reward != 0 && sale.individual_reward != undefined && sale.individual_reward != null) {
                return sale.individual_reward
            } else {
                return "Kein Preis angegeben"
            }
        },
    },
    computed: {
        saleItems() {
            let items = []
            for (var x = 0; x < this.sale.images.length; x++) {
                let imageData = this.sale.images[x]
                items.push({
                    id: imageData.id,
                    title: '',
                    path: this.$storageURL + "/sales/" + imageData.imagepath
                })
            }

            return items;
        }
    },
}
</script>

<style scoped>
.textareaPartial {
    min-width: 0px;
    margin-bottom: 0.5em
}

.errorFormField {
    border: 1px solid red;
}
</style>
